import { render, staticRenderFns } from "./waitCheckDetail.vue?vue&type=template&id=28270e8a&scoped=true"
import script from "./waitCheckDetail.vue?vue&type=script&lang=js"
export * from "./waitCheckDetail.vue?vue&type=script&lang=js"
import style0 from "./waitCheckDetail.vue?vue&type=style&index=0&id=28270e8a&prod&lang=css"
import style1 from "./waitCheckDetail.vue?vue&type=style&index=1&id=28270e8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28270e8a",
  null
  
)

export default component.exports